import { firstValueFrom } from 'rxjs';
import Step from 'shepherd.js/src/types/step';
import { PanelUtilitiesActions } from 'src/app/models/panel-utilities';
import { TourSteps } from './interface/tour-steps.interface';

export const branchStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons, services, cb}: TourSteps): Step.StepOptions[] => {
    return [
      {
        ...steps.default,
        id: 'branch1',
        title: 'Sucursales',
        text: `Ingresa al módulo "Sucursales".`,
        attachTo: {
          element: '.panel-item-2',    // @ts-ignore
          on: 'bottom'
        },
        advanceOn: {
          selector: '.panel-item-2',
          event: 'click',
        },
        canClickTarget: true,
        buttons: [{...buttons.cancel}],
        beforeShowPromise: async () => {
          return new Promise((resolve): void => {
            services.utilitiesService.existElementInDom().byClassName('panel-item-2').subscribe({
              next: async () => await firstValueFrom(services.store.dispatch(new PanelUtilitiesActions.SetIsVisible(false))),
              complete: async () => {
                await firstValueFrom(services.store.dispatch(new PanelUtilitiesActions.SetIsVisible(true)));
                resolve(true);
              }
            });
          });
        }
      },
      {
        ...steps.default,
        id: 'branch2',
        title: 'Lista de sucursales',
        text: `Aquí podrás visualizar un listado de las sucursales que tiene registradas tu clínica.`,
        attachTo: {
          element: '.shepherd-branch-list',    // @ts-ignore
          on: 'bottom'
        },
        beforeShowPromise: function () {
          return new Promise<any>(async (resolve): Promise<void> => {
            await firstValueFrom(services.store.dispatch(new PanelUtilitiesActions.SetIsVisible(false)));
            services.utilitiesService.existElementInDom().byId('shepherd-branch-list').subscribe({
              complete: () => {
                resolve(true);
              }
            });
          });
        },
      },
      {
        ...steps.default,
        id: 'branch3',
        title: 'Agregar sucursal',
        text: 'Presiona sobre le botón para registrar una nueva sucursal.',
        attachTo: {
          element: '.shepherd-branch-btn-add',    // @ts-ignore
          on: 'bottom',
        },
        advanceOn: {
          selector: '.shepherd-branch-btn-add',
          event: 'click',
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        id: 'branch3',
        title: 'Agregar sucursal',
        text: 'Para registrar una sucursal debemos ingresar algunos datos.',
        canClickTarget: false,
        attachTo: {
          element: '.shepherd-branch-modal',    // @ts-ignore
          on: 'bottom',
        },
      },
      {
        ...steps.default,
        id: 'branch4',
        title: 'Nombre',
        text: 'Define el nombre de la sucursal.',
        canClickTarget: false,
        attachTo: {
          element: '.shepherd-branch-modal-name',    // @ts-ignore
          on: 'bottom',
        }
      },
      {
        ...steps.default,
        id: 'branch5',
        title: 'Correo electrónico',
        text: 'Correo electrónico con el cual tus pacientes y/o expertos podrán ponerse en contacto con la sucursal.',
        canClickTarget: false,
        attachTo: {
          element: '.shepherd-branch-modal-email',    // @ts-ignore
          on: 'bottom',
        }
      },
      {
        ...steps.default,
        id: 'branch6',
        title: 'Zona horaria',
        text: 'Define la zona horaria donde se encuentra la sucursal. Esto ayuda a que la plataforma pueda agendar correctamente una cita, sin tener problemas por la zona horaria en las diferentes partes del mundo.',
        canClickTarget: false,
        attachTo: {
          element: '.shepherd-branch-modal-timezone',    // @ts-ignore
          on: 'bottom',
        }
      },
      {
        ...steps.default,
        id: 'branch7',
        title: 'Horario',
        text: 'Asigna un grupo de horario a la sucursal. Esto ayudará a definir los horarios en los cuales la sucursal puede atender al paciente.',
        canClickTarget: false,
        attachTo: {
          element: '.shepherd-branch-modal-schedule',    // @ts-ignore
          on: 'bottom',
        }
      },
      {
        ...steps.default,
        id: 'branch8',
        title: 'Dirección',
        text: 'Define la ubicación de la sucursal, ayuda tus pacientes y/o expertos para saber donde esta localizada.',
        canClickTarget: false,
        attachTo: {
          element: '.shepherd-branch-modal-address',    // @ts-ignore
          on: 'bottom',
        }
      },
      {
        ...steps.default,
        id: 'branch9',
        title: 'Teléfonos',
        text: 'Agrega teléfonos para ayudar a tus pacientes y/o expertos a estar en contacto con la sucursal.',
        canClickTarget: false,
        attachTo: {
          element: '.shepherd-branch-modal-phone',    // @ts-ignore
          on: 'bottom',
        }
      },
      {
        ...steps.default,
        id: 'branch10',
        title: 'Crear sucursal',
        text: 'Una vez que hayas ingresado los datos de la sucursal tendrás que dar clic en el botón para poder guardar los datos.',
        canClickTarget: false,
        attachTo: {
          element: '.shepherd-branch-modal-btn-add',    // @ts-ignore
          on: 'bottom',
        },
        buttons: [
          {
            text: 'Entendido',
            // tslint:disable-next-line:typedef
            action(): void  {
              this.next();
            },
          },
          {...buttons.cancel},
        ]
      },
      {
        ...steps.default,
        id: 'branch11',
        title: 'Tour finalizado',
        text: '¡Muy bien!. Has finalizado el tour de "Registrar sucursal".',
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              cb('goToTours');
            },
            text: 'Ir al listado de tours',
            classes: 'shepherd-button shepherd-button-secondary',
          },
          {
            // tslint:disable-next-line:typedef
            action(): void {
              cb('keepMeHere');
            },
            text: 'Mantenerme aquí'
          },
          {...buttons.cancel}
        ]
      }
    ]
  };
